import React from 'react';
import PropTypes from 'prop-types';

import {Stack, Box, Typography, Button} from 'views/components';

import {Translate, MarkdownEditor} from 'views/module';

const DescriptionBox = (props) => {
  const [newDesc, setNewDesc] = React.useState('');
  const [loading, setLoading] = React.useState(false);

  const {
    caregiverData,
    caregiverBackend,
    setIsEditing,
  } = props;

  const description = caregiverData?.description?.blob;

  React.useEffect(() => {
    setNewDesc(description);
  }, []);

  const onClickSaveEdit = () => {
    setLoading(true);
    caregiverBackend.detail.editDescription(
        newDesc,
        () => {
          setIsEditing(false);
          setLoading(false);
        },
        () => {
          setLoading(false);
        });
  };

  return (
    <Box
      sx={{
        py: 1,
        pb: 3,
      }}
    >
      <Stack spacing={1} width="100%">
        <Typography variant="subtitle1" sx={{fontWeight: 500}}>
          <Translate expression='generic.Description'/>
        </Typography>
        <MarkdownEditor
          value={newDesc}
          onChange={setNewDesc}
        />
        <Stack direction="row" spacing={1} justifyContent="flex-end">
          <Button
            variant="outlined"
            sx={{height: '42px'}}
            onClick={(event) => setIsEditing(false) }
          >
            <Translate expression='generic.Cancel'/>
          </Button>
          <Button
            sx={{height: '42px'}}
            disabled={loading}
            onClick={onClickSaveEdit}
            loading={loading}
          >
            <Translate expression='generic.Save'/>
          </Button>
        </Stack>
      </Stack>
    </Box>
  );
};
DescriptionBox.propTypes = {
  caregiverData: PropTypes.object.isRequired,
  caregiverBackend: PropTypes.object.isRequired,
  setIsEditing: PropTypes.func.isRequired,
};

export default React.memo(DescriptionBox);
